<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Sent Notifications</h1>
      </div>
    </div>
    <pickstar-loading v-if="fetchingCustomNotifications" class="m-t-lg"/>
    <div v-else class="container-fluid">
      <div class="dashboard-block onesignal-list">
        <no-results v-if="haveNoCustomNotifications">
          <div>There are no previous one signal messages.</div>
        </no-results>

        <ul class="item-detail">
          <system-custom-notifications-list-item
            v-for="(notification, index) in notifications"
            :key="notification.id"
            :index="index"
            :notification="notification"/>
        </ul>
        <div id="bottom"></div>

        <lazy-loading
          class="text-center"
          :loading="loading"
          :reached-bottom="handleGetNextCustomNotificationsCallback"
          ref="lazyLoading">
          <pickstar-loading slot="loading"/>
          <span slot="finished"></span>
        </lazy-loading>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import SystemCustomNotificationsListItem from './SystemCustomNotificationsListItem'
import LazyLoading from 'codium-lazy-loading'

export default {
  components: {
    SystemCustomNotificationsListItem,
    LazyLoading
  },

  data () {
    return {
      fetchingCustomNotifications: false
    }
  },

  mounted () {
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapState('notification', ['notifications', 'pagination']),

    /**
     * Determine if we have no notifications.
     *
     * @return bool
     */
    haveNoCustomNotifications () {
      return this.notifications.length === 0
    }
  },

  watch: {
    '$route' () {
      this.handleGetCustomNotificationsCallback()
    }
  },

  created () {
    this.handleGetCustomNotificationsCallback()
  },

  methods: {

    ...mapActions('notification', ['getCustomNotifications', 'getNextCustomNotifications']),

    handleGetCustomNotificationsCallback () {
      this.fetchingCustomNotifications = true

      return this.getCustomNotifications()
        .catch(this.handleServerErrorsCallback)
        .finally(() => {
          this.fetchingCustomNotifications = false

          this.$nextTick(() => {
            if (!this.$refs.lazyLoading) {
              return
            }

            this.$refs.lazyLoading.$emit('reset')
          })
        })
    },

    handleGetNextCustomNotificationsCallback () {
      return this.getNextCustomNotifications()
        .catch(this.handleServerErrorsCallback)
    }
  }
}
</script>
